<template>
    <header class="header">
        <router-link @click.native="navActive=false" to="/"><img class="header__logo" src="../assets/img/Iivaara_logo1.png" alt="Iivaara lodge logo"></router-link>
        <div class="header__nav">
            <router-link to="/">{{$t('nav.home')}}</router-link>
            <router-link to="/accommodatie">{{$t('nav.accommodation')}}</router-link>
            <router-link to="/activiteiten">{{$t('nav.activities')}}</router-link>
            <router-link to="/omgeving">{{$t('nav.environment')}}</router-link>
            <router-link to="/contact">{{$t('nav.contact')}}</router-link>
        </div>
        <div class="header__lang">
            <LanguageSelector></LanguageSelector>
        </div>
        <div class="header__mobnav">
            <fa-icon icon="bars" @click="navActive=true"></fa-icon>
        </div>
        <div class="mobnav" v-if="navActive">
            <div class="mobnav__wrapper">
                <div class="mobnav__wrapper__close">
                    <fa-icon icon="times" @click="navActive=false"></fa-icon>
                </div>
                <router-link @click.native="navActive=false" to="/"><span>{{$t('nav.home')}}</span></router-link>
                <router-link @click.native="navActive=false" to="/accommodatie"><span>{{$t('nav.accommodation')}}</span>
                </router-link>
                <router-link @click.native="navActive=false" to="/activiteiten"><span>{{$t('nav.activities')}}</span>
                </router-link>
                <router-link @click.native="navActive=false" to="/omgeving"><span>{{$t('nav.environment')}}</span>
                </router-link>
                <router-link @click.native="navActive=false" to="/contact"><span>{{$t('nav.contact')}}</span>
                </router-link>
                <div class="mobnav__wrapper__lang">
                    <LanguageSelector></LanguageSelector>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import LanguageSelector from "./LanguageSelector";

    export default {
        name: "TheHeader",

        components: {
            LanguageSelector
        },

        data() {
            return {
                navActive: false
            };
        }
    }
</script>